import { render, staticRenderFns } from "./block-warning.vue?vue&type=template&id=87e01cca&scoped=true&"
import script from "./block-warning.vue?vue&type=script&lang=js&"
export * from "./block-warning.vue?vue&type=script&lang=js&"
import style0 from "./block-warning.vue?vue&type=style&index=0&id=87e01cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e01cca",
  null
  
)

export default component.exports